<div class="search-overlay-dim"></div>
<div class="search-overlay container">

  <div class="d-flex justify-content-end mt-2 p-4 px-sm-5">
    <button class="search-overlay-button border-0 p-0 close-search-button" (click)="hide()">
      <app-x-icon [size]="2"></app-x-icon>
    </button>
  </div>

  <div class="row px-4 px-sm-5">
    <form [formGroup]="searchForm" class="w-100 p-0" id="search-form">
      <label class="form-label" for="search">Search the Software Store</label>
      <div class="input-group mt-1">
          <span class="search input-group-text bg-white border-end-0">
              <app-search-icon [size]="2"></app-search-icon>
          </span>
        <input class="form-control form-control-lg border-start-0 border-end-0 ps-1 search-input"
               formControlName="searchControl"
               id="search"
               placeholder="Search"
               type="text">
        <span class="input-group-text bg-white border-start-0">
            <app-arrow-right-icon [size]="2"></app-arrow-right-icon>
        </span>
      </div>
    </form>
  </div>

  <div class="row px-4 px-sm-5 mt-3">
    <div class="col-12 px-0">
      <div *ngIf="hasProducts; else missingProducts">
        <ul class="p-0 list-unstyled" *ngIf="hasSearchResults">
          <li class="mt-4 search-result" *ngFor="let product of searchResults">
            <app-search-result (click)="hide()" [product]="product"></app-search-result>
          </li>
        </ul>
        <p class="mt-4 no-search-results text-center" *ngIf="searching && !hasSearchResults">No Matching Products</p>
      </div>
      <ng-template #missingProducts>
        <p class="mt-4 missing-search-products text-start">Unable to search no products loaded</p>
      </ng-template>
    </div>
  </div>

  <div class="row px-4 px-sm-5 mt-5">
    <p class="p-0">More Links</p>
  </div>
  <div class="row px-4 px-sm-5">
    <ul class="p-0 list-unstyled">
      <li class="mb-2"><a routerLink="./adobe/" target="_blank">Adobe Creative Cloud<br></a></li>
      <li class="mb-2"><a href="https://o365cloud.utah.edu/" target="_blank">Microsoft Office<br></a></li>
      <li class="mb-2"><a href="https://software.utah.edu/mathworks.php" target="_blank">MatLab Products<br></a></li>
      <li class="mb-2"><a href="https://tlt.utah.edu/forms/zoom-pro-license-request.php" target="_blank">Zoom Pro
        Licenses<br></a></li>
    </ul>
  </div>

</div>
